//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    data: function data() {
        return {
            person: {},
            email_preference: false,
            sms_preference: false,
            phone_preference: false,
            selectedBuilding: '',
            property_id: '',
            selectedUnit: [],
            units: [],
            buildings: [],
            users: [],
            leaseBuildings: [],
            leaseUnits: [],
            contact_preference: "",
            lease_property: '',
            selectedLeaseBuilding: "",
            selectedLeaseUnit: "",
            sources: ['Drive by', 'Resident referral', 'Former resident referral', 'Employee referral', 'Other word of mouth', 'Other Community referral', 'Google', 'Property website', 'Zillow', 'Trulia', 'Costar', 'Rentpath', 'Craigs list', 'Facebook Marketplace', 'Apartment Locator service', 'Flyer, Radio, Newspaper advertisement'],
            formData: {},
            properties: [],
            pet_breeds: ['Pit Bull Terriers', 'Staffordshire Terriers', 'Rottweilers', 'German Shepherds', 'Presa Canarios', 'Chows Chows', 'Doberman Pinschers', 'Akitas', 'Wolf-hybrids', 'Mastiffs', 'Cane Corsos', 'Great Danes', 'Alaskan Malamutes', 'Siberian Huskies']
        };
    },
    created: function created() {
        var _this = this;

        Event.$on('edit-guest-card', function (item) {
            _this.getProperties();
            _this.getUsers();
            _this.editGuestCard(item);
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('edit-guest-card');
    },

    methods: {
        getUsers: function getUsers() {
            var _this2 = this;

            axios.get('/prototype/users/all').then(function (response) {
                _this2.users = response.data;
            });
        },
        getProperties: function getProperties() {
            var _this3 = this;

            axios.get('/prototype/get-properties').then(function (response) {
                _this3.properties = response.data;
            });
        },
        editGuestCard: function editGuestCard(item) {
            var $el = this;
            $el.person = item;
            $el.firstOrSecond = true;
            $el.firstOrSecondLeased = true;
            $el.selectedUnit = isNaN(item.unit_id) ? JSON.parse(item.unit_id) : '';
            $el.selectedBuilding = item.building;
            $el.contact_preference = item.contact_preference ? item.contact_preference : '';
            $el.lease_property = item.lease_property ? item.lease_property : '';
            $el.selectedLeaseBuilding = item.lease_building;
            $el.selectedLeaseUnit = item.lease_unit ? item.lease_unit : '';
            $el.person.selected_agent = item.leasing_agent ? { 'id': item.leasing_agent.id, 'label': '(' + item.leasing_agent.id + ') ' + item.leasing_agent.first_name + ' ' + item.leasing_agent.last_name } : '';
            $el.$children[0].$data.showModal = true;
        },
        updateGuestCard: function updateGuestCard() {
            var _this4 = this;

            this.person.property = this.property_id.id;
            this.person.unit_id = JSON.stringify(this.selectedUnitsArray);
            this.person.building_id = this.selectedBuilding ? this.selectedBuilding.id : 0;
            this.person.lease_property = this.lease_property.id;
            this.person.contact_preference = this.contact_preference;
            this.person.lease_building = this.selectedLeaseBuilding ? this.selectedLeaseBuilding.id : 0;
            this.person.lease_unit = this.selectedLeaseUnit ? this.selectedLeaseUnit.id : 0;
            axios.put('/prototype/person/' + this.person.id, this.person).then(function (response) {
                _this4.$snotify.success('The person was updated');
                Event.$emit('person-updated');
                Event.$emit('guest-card-dashboard-updated');
                Event.$emit('close-full-modal');
            });
        },
        setContactPreference: function setContactPreference(contactPreference) {
            this.contact_preference = contactPreference;
        },
        cancelGuestCard: function cancelGuestCard() {
            var $el = this;
            Event.$emit('close-full-modal');
        }
    },

    watch: {
        selectedBuilding: function selectedBuilding() {
            var $el = this;
            if ($el.selectedBuilding) {
                if (!$el.firstOrSecond) {
                    $el.selectedUnit = [];
                }
                $el.units = $el.selectedBuilding.units;
            }
        },

        property_id: function property_id() {
            var $el = this;
            if ($el.property_id) {
                if (!$el.firstOrSecond) {
                    $el.selectedBuilding = "";
                    $el.selectedUnit = [];
                }
                axios.get('/prototype/person/guest-card/selected-building?id=' + $el.property_id.id).then(function (response) {
                    $el.buildings = response.data;
                });
            }
            $el.firstOrSecond = false;
        },

        lease_property: function lease_property() {
            var $el = this;
            if ($el.lease_property) {
                if (!$el.firstOrSecondLeased) {
                    $el.selectedLeaseBuilding = "";
                    $el.selectedLeaseUnit = "";
                }
                axios.get('/prototype/person/guest-card/selected-building?id=' + $el.lease_property.id).then(function (response) {
                    $el.leaseBuildings = response.data;
                });
            }
        },

        selectedLeaseBuilding: function selectedLeaseBuilding() {
            var $el = this;
            if ($el.selectedLeaseBuilding) {
                if (!$el.firstOrSecondLeased) {
                    $el.selectedLeaseUnit = "";
                }
                var payLoad = [];
                $el.selectedLeaseBuilding.units.map(function (unit) {
                    if (unit.status == 'Vacant - Leased') {
                        payLoad.push({ "name": unit.name, "id": unit.id });
                    }
                });
                $el.leaseUnits = payLoad;
            }
            $el.firstOrSecondLeased = false;
        }
    },

    computed: {
        selectedUnitsArray: function selectedUnitsArray() {
            var payLoad = [];
            if (this.selectedUnit) {
                this.selectedUnit.map(function (unitArray) {
                    payLoad.push({ "name": unitArray.name, "id": unitArray.id });
                });
            }
            return payLoad;
        },
        leasingAgents: function leasingAgents() {

            return this.users.map(function (u) {
                return {
                    label: '(' + u.id + ') ' + u.first_name + ' ' + u.last_name,
                    id: '' + u.id
                };
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/guest-cards/EditGuestCard.vue
// module id = wbqE
// module chunks = 0 1